import './person-card.scss';

import FeatherIcon from 'feather-icons-react';
import React from 'react';

import type { Person } from '../../../content/types/person';
import { PersonAvatar } from './PersonAvatar';

export const PersonCard: React.FC<Person> = (props) => {
  return (
    <div className="card card-hover border-0 bg-transparent">
      <div className="position-relative person-card-photo">
        <PersonAvatar name={props.name} src={props.image} size="lg" />
        <div className="card-img-overlay d-flex flex-column align-items-center justify-content-center rounded-circle">
          <span className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25 rounded-circle"></span>
          <div className="position-relative d-flex zindex-2">
            {props.social.linkedin && (
              <a
                href={props.social.linkedin}
                target="_blank"
                rel="noreferrer"
                className="btn btn-icon btn-secondary btn-linkedin btn-sm bg-white me-2"
              >
                <i className="bx bxl-linkedin"></i>
                <FeatherIcon icon="linkedin" size="16" className="fs-lg ms-1" />
              </a>
            )}
            {props.social.github && (
              <a href={props.social.github} className="btn btn-icon btn-secondary btn-github btn-sm bg-white">
                <FeatherIcon icon="github" size="16" className="fs-lg ms-1" />
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="card-body text-center p-3">
        <h3 className="fs-lg fw-semibold pt-1 mb-2">{props.name}</h3>
        <p className="fs-sm mb-0 person-role">{props.role}</p>
      </div>
    </div>
  );
};
